import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditServiceInvoice from "./EditServiceInvoice";
import { getServiceInvoiceList, lineItemsUpdate, getServicesOnDemand, lineItemsApprovalRejection, convertServiceInvoice } from "services/redux/sales/postSales/action";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";


const mapStateToProps = (state) => ({
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
    lineItems: state.postSalesReducer.lineItems,
    onDemandServicesList: state.postSalesReducer.onDemandServicesList,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getServiceInvoiceList,
            lineItemsUpdate,
            getServicesOnDemand,
            lineItemsApprovalRejection,
            convertServiceInvoice,
            documentUploadUrlPublic
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EditServiceInvoice);
